import {applyMiddleware, createStore} from 'redux'
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly'
import {handleFuture, inject} from './middleware'
import reducer from './reducer'

import * as login from './login/actions'
import * as search from './search/actions'
import * as report from './report/actions'

export const loginActions = login
export const searchActions = search
export const reportActions = report

export default (deps) =>
  createStore(
    reducer,
    composeWithDevTools(
      applyMiddleware(
        inject(deps),
        handleFuture,
      ),
    )
  )



// WEBPACK FOOTER //
// ./src/store/index.js